import * as React from 'react';
import type { Todo } from 'owa-todo-types';
import { isTaskComplete } from 'owa-todo-utils';
import { usePatchPayload, useProjectId, useAssetId } from 'owa-timestream-asset-sdk';
import { createTask } from 'owa-timestream-asset-sdk-tasks';
import type { TaskViewPayload } from '../schema';

export default function useCreateTask() {
    const projectId = useProjectId();
    const assetId = useAssetId();
    const patchPayload = usePatchPayload<TaskViewPayload>();

    const onTaskCreated = React.useCallback(
        (todo: Todo) => {
            patchPayload(
                {
                    taskId: todo.Id,
                    taskSubject: todo.Subject,
                    isComplete: isTaskComplete(todo.Status),
                },
                { taskId: todo.Id }
            );
        },
        [projectId, assetId]
    );

    return React.useCallback(
        (taskFolderId: string, taskSubject: string) => {
            createTask(
                projectId,
                assetId,
                taskFolderId,
                taskSubject,
                undefined /* dueDate */,
                onTaskCreated
            );
        },
        [projectId, assetId]
    );
}
